import { defaultTheme } from './../../theming/data/defaultTheme'
import styled from 'styled-components'
import border from '../../tokens/border'
import colors from '../../tokens/colors'
import fonts from '../../tokens/fonts'
import layout from '../../tokens/layout'
import { composeTheme } from '../../utils/compose-theme'

interface Props {
  isOpen: boolean
}

const CollapseContainer = styled.section.attrs((props) =>
  composeTheme(props),
)<Props>`
  display: grid;

  * {
    box-sizing: border-box;
    padding: 0;
    margin: 0;
    font-family: ${fonts.inter};
    font-size: ${(props) => props.theme.collapse.fontSize};
    font-weight: ${(props) => props.theme.collapse.fontWeight};
    user-select: none;
  }

  header {
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: ${layout.margin.spacingXxxs};
    border-radius: ${(props) => props.theme.collapse.borderRadius};
    padding: ${(props) => props.theme.collapse.padding};
    border-width: ${(props) => props.theme.collapse.borderWidth};
    border-style: solid;

    border-color: ${(props) =>
      props.isOpen
        ? props.theme.collapse.openBorderColor ||
          props.theme.brandColors.primaryPure
        : props.theme.collapse.borderColor};

    background-color: ${(props) =>
      props.isOpen
        ? props.theme.collapse.openBackgroundColor ||
          props.theme.brandColors.primaryLight
        : props.theme.collapse.backgroundColor};

    border-bottom-left-radius: ${(props) =>
      props.isOpen ? border.radius.radiusNone : border.radius.radiusSm};
    border-bottom-right-radius: ${(props) =>
      props.isOpen ? border.radius.radiusNone : border.radius.radiusSm};

    h3.title {
      flex-grow: 1;
      color: ${(props) =>
        props.isOpen
          ? props.theme.collapse.openColor
          : colors.neutralColorLowPure};
    }
  }

  article.content {
    padding: ${layout.padding.spacingInsetNone};
    margin: ${layout.margin.spacingNone};
    border: ${border.width.widthHairline} solid ${colors.neutralColorHighLight};
    height: 0px;

    &.details {
      height: 100%;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.13);
      transition: height 0.3s ease-out;
    }
  }

  svg.MuiSvgIcon-root {
    color: ${(props) =>
      props.isOpen
        ? props.theme.collapse.openIconColor ||
          props.theme.brandColors.primaryPure
        : props.theme.collapse.iconColor};
  }
`
CollapseContainer.defaultProps = defaultTheme

export const CollapseStyles = {
  CollapseContainer,
}
